import apiClient from '../utils/apiClient';

const portfolioService = {
  getOverview: () => apiClient.get('/api/portfolio/overview'),
  getPricingRecommendations: (facilityId) =>
    apiClient.get(`/api/facilities/${facilityId}/pricing-recommendations`),
  getChurnRisk: (facilityId, limit = 50) =>
    apiClient.get(`/api/facilities/${facilityId}/churn-risk`, { params: { limit } }),
  getDemandForecast: (facilityId) =>
    apiClient.get(`/api/facilities/${facilityId}/demand-forecast`),
};

export default portfolioService;
